export type ServiceCardObjectFit = "cover" | "contain"

export const DEFAULT_SERVICE_IMAGE_OBJECT_FIT: ServiceCardObjectFit = "cover"

export function normalizeServiceImageObjectFit(value: unknown): ServiceCardObjectFit {
  return value === "contain" ? "contain" : "cover"
}

export function serviceImageObjectFitClass(objectFit: ServiceCardObjectFit): string {
  return objectFit === "contain" ? "object-contain" : "object-cover"
}
